module.exports = __webpack_public_path__ + "img/stat-card-2.59e63a2d.png";